import { useEffect, useRef } from 'react';
import { useDispatch } from 'react-redux';

import {
    setDataVacancyAdvicesModal,
    setRatingVacancyAdvicesModal,
    VacancyAdvicesModals,
} from 'src/models/vacancyAdvicesModal';

import {
    VacancyAdviceModalEventType,
    VACANCY_ADVICE_MODAL_SOURCE_EVENT,
    VACANCY_ADVICE_MODAL_COMPONENT_EVENT,
} from 'src/components/VacancyAdvicesModal/constants';
import { SetRatingDetail, VacancyAdviceModalEventDetailMap } from 'src/components/VacancyAdvicesModal/types';

/**
 * Event-handler - cлушает события сервиса в котором размещен как прокси-компонент
 */
const useProxyVacancyAdviceModalEvent = (onSendFeedback: () => void): void => {
    const dispatch = useDispatch();
    const initializedRef = useRef(false);

    // Компонент грузится на клик, необходимо отправить событие, что компонент инициализирован
    useEffect(() => {
        if (!initializedRef.current) {
            const initEvent = new CustomEvent(VACANCY_ADVICE_MODAL_COMPONENT_EVENT, {
                detail: {
                    type: VacancyAdviceModalEventType.Init,
                },
            });
            window.dispatchEvent(initEvent);
            initializedRef.current = true;
        }
    }, [dispatch]);

    useEffect(() => {
        const setDataModalHandler = (detail: VacancyAdvicesModals) => {
            dispatch(setDataVacancyAdvicesModal(detail));
        };

        const setRatingHandler = (detail: SetRatingDetail) => {
            dispatch(setRatingVacancyAdvicesModal(detail.rating));
        };

        const vacancyAdviceModalSourceEventHandler = <T extends keyof VacancyAdviceModalEventDetailMap>(
            e: CustomEventInit<VacancyAdviceModalEventDetailMap[T]>
        ) => {
            switch (e.detail?.type) {
                case VacancyAdviceModalEventType.SetData:
                    setDataModalHandler(e.detail);
                    break;

                case VacancyAdviceModalEventType.SetRating:
                    setRatingHandler(e.detail);
                    break;

                case VacancyAdviceModalEventType.SendFeedback:
                    onSendFeedback();
                    break;

                default:
                    break;
            }
        };

        window.addEventListener(VACANCY_ADVICE_MODAL_SOURCE_EVENT, vacancyAdviceModalSourceEventHandler);
        return () =>
            window.removeEventListener(VACANCY_ADVICE_MODAL_SOURCE_EVENT, vacancyAdviceModalSourceEventHandler);
    }, [dispatch, onSendFeedback]);
};

export default useProxyVacancyAdviceModalEvent;
